module.exports = __webpack_public_path__ + "img/coinbankC35.5b220893.jpg";